import { initialCandidateAppliedForList } from '../../../pages/Recruitment/CandidateList/CandidateListHelpers'
import { initialCountry } from '../../../pages/Recruitment/InterviewStatusReport/InterviewStatusReportHelpers'
import { IncomingEditCandidateData } from '../../../types/Recruitment/CandidateList/CandidateListTypes'

export const initialEditCandidateData: IncomingEditCandidateData = {
  candidateName: '',
  candidateFirstName: '',
  candidateLastName: '',
  candidateEmail: '',
  experience: '',
  skills: '',
  mobile: '',
  appliedFor: initialCandidateAppliedForList,
  sourceType: '',
  sourceName: '',
  uploadResume: null,
  otherDocs: null,
  status: '',
  candidateId: -1,
  appliedForLookUp: '',
  vacancyId: -1,
  scheduleDate: null,
  scheduleTime: null,
  interviewerEmailid: null,
  receipentEmailId: null,
  description: null,
  scheduleFlag: null,
  interviewRound: null,
  interviewersDTOList: null,
  interviewerId: null,
  interviewType: null,
  interviewStatus: null,
  dob: '',
  timelineStatus: null,
  technology: '',
  recruiter: null,
  ctc: '',
  ectc: '',
  np: '',
  reason: '',
  skypeId: null,
  currentEmployer: null,
  currentLocation: '',
  sendMailToCandidate: null,
  sendMailToInterviewer: null,
  sendMessageToCandidate: null,
  sendMessageToInterviewer: null,
  jobTypeName: '',
  pan: null,
  adhar: null,
  linkedin: null,
  countryId: initialCountry.id,
  country: initialCountry,
  notifications: 'Yes',
  contactDetails: null,
  countryCode: initialCountry.id,
}
